import classNames from 'classnames';

import { LogoRowsFragmentFragment } from '../../__generated__/graphql';
import Svg from '../../components/Svg';
import Section from '../../layout/Section';
import SectionTitle from '../../layout/Section/SectionTitle';
import { ContentBlock } from '../types';

import style from './logo-rows.module.css';

const LogoRows: ContentBlock<LogoRowsFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.logoRows;

  if (!contentBlockProps) {
    return null;
  }

  return (
    <Section
      backgroundColor={contentBlockProps.darkBackground ? 'black' : 'white'}
      id={contentBlockProps.sectionId}
    >
      <SectionTitle>
        {contentBlockProps.title}
      </SectionTitle>

      <div className={style.logoRows}>
        {contentBlockProps.logos?.map(logo => {
          if (logo?.logo) {
            return (
              <Svg
                containerClassName={classNames(
                  style.logoImage,
                  {
                    [style.logoImageSvg]: !!(logo.logo.node.mimeType)?.includes('svg'),
                  },
                )}
                image={logo.logo}
                key={logo.logo.node.sourceUrl}
                maxWidth={logo.maxWidth}
              />
            );
          }
        })}
      </div>
    </Section>
  );
};

export default LogoRows;
